import { message } from "antd";
import { MessageKey } from "../../constants/Reusabels";

export const MsgLoading = () => {
  message.open({
    key: MessageKey,
    type: "loading",
    content: "Loading",
  });
};

export const MsgSuccess = (successMsg: string) => {
  message.open({
    key: MessageKey,
    type: "success",
    content: successMsg,
  });
};

export const MsgError = (errMsg: string) => {
  message.open({
    key: MessageKey,
    type: "error",
    content: errMsg,
  });
};
